import React from 'react';
import PropTypes from 'prop-types';
import lodashNoop from 'lodash/noop';
import FilterIcon from '../common/FilterIcon';
import FilterIndicator from '../common/FilterIndicator';
import Button from '@adsk/bim360-matrix-react-button';
import i18n from '../../utils/i18n';
import TemplatesSearchDropdownContainer from './TemplatesSearchDropdownContainer';
import {TYPE_QUALITY_ISSUES} from '../../constants/issue-types';

const TemplatesProjectGridHeader = props => {
  const {
    isFiltered,
    isFilterPanelOpen,
    toggleFilterPanel,
    resetFilters,
    changeLocationAction,
    openManageTemplateCategoriesModal
  } = props;

  return (
    <div className="TemplatesProjectGridHeader">
      <div className="TemplatesProjectGridHeader__left-buttons">
        <FilterIcon isFilterOpen={isFilterPanelOpen} toggleFilterPanel={toggleFilterPanel} />
        <TemplatesSearchDropdownContainer />
        {isFiltered && (
          <FilterIndicator onClick={isFilterPanelOpen ? lodashNoop : toggleFilterPanel} resetFilters={resetFilters} />
        )}
      </div>
      <div className="TemplatesProjectGridHeader__right-buttons">
        <Button
          className="TemplatesProjectGridHeader__manage-categories-button"
          onClick={openManageTemplateCategoriesModal}
          data-testid="TemplatesProjectGridHeader__manage-categories-button"
        >
          {i18n.t('templatesGrid.buttons.manageCategories')}
        </Button>
        <Button
          styleType={Button.StyleType.PRIMARY}
          className="TemplatesProjectGridHeader__create-button"
          onClick={() => changeLocationAction(`/project/${TYPE_QUALITY_ISSUES}/templates/new`)}
          data-testid="TemplatesProjectGridHeader__create-button"
        >
          {i18n.t('templatesGrid.buttons.create')}
        </Button>
      </div>
    </div>
  );
};

TemplatesProjectGridHeader.displayName = 'TemplatesProjectGridHeader';

TemplatesProjectGridHeader.propTypes = {
  isFiltered: PropTypes.bool.isRequired,
  isFilterPanelOpen: PropTypes.bool.isRequired,
  toggleFilterPanel: PropTypes.func.isRequired,
  resetFilters: PropTypes.func.isRequired,
  changeLocationAction: PropTypes.func.isRequired,
  openManageTemplateCategoriesModal: PropTypes.func.isRequired
};

export default TemplatesProjectGridHeader;
